// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import MenuRoutes from './MenuRoutes';
import { Navigate, useLocation } from 'react-router-dom';
import Button from '../_common/form/Button';

export const ForceNavigate = ({ id, ...props }) => {
    const { setForcedLocation } = useGlobalState();
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const routes = MenuRoutes();
    const route = routes[query.get('to') || 'washes'].route
    return (
        <Button
            onClick={() => setForcedLocation(id)}
            to={`${route}?location=${id}&forced=true`}
        >
            {query.get('label') || 'Washes'}
        </Button>
    )
}

const ForceLocation = ({ route, children, ...props }) => {
    const {
        state: {
            site_config,
            active_user
        },
    } = useGlobalState();

    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const routes = MenuRoutes();

    const translateRoute = () => {
        switch (route) {
            case 'washClub':
                return '?to=washClub&label=Wash+Clubs';
            case 'bundles':
                return '?to=deals&label=Bundles';
            case 'giftCards':
                return '?to=giftCards&label=Gift+Cards';
            default:
                return '?to=washes&label=Washes';
        }
    }

    if (site_config.forceLocations && !query.get('forced') && !active_user.forcedLocation) {
        return <Navigate to={routes.findUs.route + translateRoute(route)} replace />;
    }

    return children
}

export default ForceLocation;